import { post, get } from './request'

export let startAudit = (payload, success, failure) => post(`/api/app/${payload.app_id}/audit`, payload, success, failure)
export let loadAppAudit = (payload, success, failure) => get(`/api/app/${payload.app_id}/audit/${payload.audit_id}`, success, failure)
export let deleteAudit = (payload, success, failure) => post(`/api/audit/${payload}/delete`, {}, success, failure)